import WarehousesStatistic from './WarehousesStatistic';

export default WarehousesStatistic;
